"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { getTradingPair } from "@/service/api";
import digio from "@/assets/icons/digi.png";
import trm from "@/assets/icons/TRMfull.png";
import trading from "@/assets/icons/tradingfull.png";
import nota from "@/assets/icons/notabene.svg";

const CryptoPlateform = () => {
  const [pairs, setPairs] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchTradingPairs();
  }, [""]);

  const marketingDemo = [
    {
      logo: digio,
      title: "Digio",
    },
    {
      logo: trm,
      title: "TRM Labs",
    },
    {
      logo: trading,
      title: "Trading View",
    },
    {
      logo: nota,
      title: "Notabene",
    },
  ];

  const fetchTradingPairs = async () => {
    // setIsLoading(true);
    let params: any = {
      page: 1,
      sizePerPage: 100,
      pagination: false,
    };

    try {
      const response = await getTradingPair(params);
      if (response.status) {
        setPairs(response?.data?.result);
      }
    } catch (error) {
      console.error("Error fetching pairs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="w-full">
      <div className="container-wrapper py-12 px-4 sm:px-6 lg:px-12 mx-auto flex flex-col gap-4 mt-[44px]">
        {/* Title */}
        <div className="w-full flex flex-wrap justify-center gap-2 items-center text-center">
          <span className="text-black text-[18px] font-outfit">Our</span>
          <span className="text-textGreen text-[18px] font-outfit">
            Global Partners
          </span>
        </div>

        {/* Cards */}
        <div className="w-full px-2">
          <Cards cryptoList={marketingDemo} />
        </div>
      </div>
    </section>
  );
};

export default CryptoPlateform;

const Cards = ({ cryptoList }: any) => {
  return (
    <div className="w-full flex flex-wrap justify-center gap-3">
      {cryptoList?.map((item: any, index: any) => (
        <div
          key={index}
          className="w-full sm:w-[45%] md:w-[30%] lg:w-[18%] px-4 py-4 flex items-center justify-center gap-3 rounded-xl max-h-[80px]"
        >
          {item?.title === "Digio" ? (
            <Image
              onContextMenu={(e) => e.preventDefault()}
              src={item.logo}
              alt={item.title}
              className="size-fit object-cover max-h-[50px] filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          ) : (
            <Image
              onContextMenu={(e) => e.preventDefault()}
              src={item.logo}
              alt={item.title}
              className="size-fit object-cover max-h-[80px] filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          )}
          {/* <h6 className="text-[18px] md:text-[20px] text-smallText leading-6 tracking-[0.15px] font-outfit">
            {item.title}
          </h6> */}
        </div>
      ))}
    </div>
  );
};
